import { Tooltip } from '@mui/material';
import { useThemeMode } from '../../theme/ThemeModeContext';
import './ThemeSwitcher.css';

export const ThemeSwitcher = () => {
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip title="Switch theme">
      <label className="switch" style={{ margin: '0 6px 0 0' }} aria-label="Switch theme">
        <input
          type="checkbox"
          id="theme-switcher"
          checked={isDark}
          onChange={toggleMode}
          aria-label="toggle theme mode"
        />
        <span className="slider round-switcher" />
      </label>
    </Tooltip>
  );
};
